import Vue from 'vue'
import Router from 'vue-router'
// import { resolve } from '../../config/dev.env'
Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [
    // {
    //   path: '*',
    //   redirect: '/'
    //   // name: 'HelloWorld',
    //   // component: resolve => require(['@/components/HellowWorld'], resolve) // 首页
    // },
    {
      path: '/',
      name: 'HelloWorld',
      component: resolve => require(['@/components/HellowWorld'], resolve) // 首页
    },
    {
      path: '/ProductSolutions',
      name: 'ProductSolutions',
      component: resolve => require(['@/components/ProductSolutions/index'], resolve) // 产品与解决方案
    },
    {
      path: '/CooperativeTranslation',
      name: 'CooperativeTranslation',
      component: resolve => require(['@/components/CooperativeTranslation/index'], resolve) // 合作伙伴
    },
    {
      path: '/JoinUs',
      name: 'JoinUs',
      component: resolve => require(['@/components/JoinUs/index'], resolve) // 加入我们
    },
    {
      path: '/AboutUs',
      name: 'AboutUs',
      component: resolve => require(['@/components/AboutUs/index'], resolve) // 关于我们
    },
    {
      path: '/InfoDetail',
      name: 'InfoDetail',
      component: resolve => require(['@/components/AboutUs/InfoDetail.vue'], resolve) // 动态信息
    },
    /*
    OnlineFinance 文件夹为 "互联网金融"
    */
    {
      path: '/CollectionSystem',
      name: 'CollectionSystem',
      component: resolve => require(['@/components/ProductSolutions/OnlineFinance/CollectionSystem.vue'], resolve) // 互联网核心系统
    },
    {
      path: '/PaymentSystem',
      name: 'PaymentSystem',
      component: resolve => require(['@/components/ProductSolutions/OnlineFinance/PaymentSystem.vue'], resolve) // 互联网核心系统
    },
    // 区块链及web3系统
    {
      path: '/BlockchainWeb3',
      name: 'BlockchainWeb3',
      component: resolve => require(['@/components/ProductSolutions/FinancialWork/BlockchainWeb3.vue'], resolve)
    },
    // 数字人民币系统
    {
      path: '/DigitalYuan',
      name: 'DigitalYuan',
      component: resolve => require(['@/components/ProductSolutions/Core/DigitalYuan.vue'], resolve)
    },
    /*
    InternetBanking 文件夹为 "互联网金融"
    */
    {
      path: '/InternetCoreSystem',
      name: 'InternetCoreSystem',
      component: resolve => require(['@/components/ProductSolutions/InternetBanking/InternetCoreSystem'], resolve) // 互联网核心系统
    },
    {
      path: '/FundDepositorySystem',
      name: 'FundDepositorySystem',
      component: resolve => require(['@/components/ProductSolutions/InternetBanking/FundDepositorySystem'], resolve) // 资金存托管系统
    },
    {
      path: '/OverseasEwalletAndPaymentSystem',
      name: 'OverseasEwalletAndPaymentSystem',
      component: resolve => require(['@/components/ProductSolutions/InternetBanking/OverseasEwalletAndPaymentSystem'], resolve) // 海外电子钱包及支付系统
    },
    {
      path: '/DawanDistrictComprehensiveFinanCialManagementSystem',
      name: 'DawanDistrictComprehensiveFinanCialManagementSystem',
      component: resolve => require(['@/components/ProductSolutions/InternetBanking/DawanDistrictComprehensiveFinanCialManagementSystem'], resolve) // 大湾区综合理财系统
    },
    {
      path: '/AggregatePaymentSystem',
      name: 'AggregatePaymentSystem',
      component: resolve => require(['@/components/ProductSolutions/InternetBanking/AggregatePaymentSystem'], resolve) // 聚合支付系统
    },
    {
      path: '/MerchantManagementAndIntegratedAcquiringSystem',
      name: 'MerchantManagementAndIntegratedAcquiringSystem',
      component: resolve => require(['@/components/ProductSolutions/InternetBanking/MerchantManagementAndIntegratedAcquiringSystem'], resolve) // 商户管理及综合收单系统
    },
    {
      path: '/OverseasVirtualCardManagement',
      name: 'OverseasVirtualCardManagement',
      component: resolve => require(['@/components/ProductSolutions/InternetBanking/OverseasVirtualCardManagement'], resolve) // 海外虚拟卡管理系统
    },
    {
      path: '/OverseasMobileBankingAndInternetBankingSystem',
      name: 'OverseasMobileBankingAndInternetBankingSystem',
      component: resolve => require(['@/components/ProductSolutions/InternetBanking/OverseasMobileBankingAndInternetBankingSystem'], resolve) // 海外手机银行及网银系统
    },
    {
      path: '/OverseasRemoteAccountOpeningSystem',
      name: 'OverseasRemoteAccountOpeningSystem',
      component: resolve => require(['@/components/ProductSolutions/InternetBanking/OverseasRemoteAccountOpeningSystem'], resolve) // 海外远程开户系统
    },
    {
      path: '/AMLAntiMoneyLaunderingSystem',
      name: 'AMLAntiMoneyLaunderingSystem',
      component: resolve => require(['@/components/ProductSolutions/InternetBanking/AMLAntiMoneyLaunderingSystem'], resolve) // AML反洗钱系统
    },
    {
      path: '/AppAndWeChatSmallProgramDevelopment',
      name: 'AppAndWeChatSmallProgramDevelopment',
      component: resolve => require(['@/components/ProductSolutions/InternetBanking/AppAndWeChatSmallProgramDevelopment'], resolve) // App及微信小程序开发
    },
    {
      path: '/CrossBorderCollection',
      name: 'CrossBorderCollection',
      component: resolve => require(['@/components/ProductSolutions/InternetBanking/CrossBorderCollection'], resolve)
    },
    /*
      NetworkIntegratedCreditAndRiskControl 文件夹为 "网络综合信贷及风控"
    */
    {
      path: '/BuyNowPayLater',
      name: 'BuyNowPayLater',
      component: resolve => require(['@/components/ProductSolutions/NetworkIntegratedCreditAndRiskControl/BuyNowPayLater'], resolve) // 网络消费分期及现金贷系统
    },
    {
      path: '/NetworkConsumptionInstallmentAndCashLoadSystem',
      name: 'NetworkConsumptionInstallmentAndCashLoadSystem',
      component: resolve => require(['@/components/ProductSolutions/NetworkIntegratedCreditAndRiskControl/NetworkConsumptionInstallmentAndCashLoadSystem'], resolve) // 网络消费分期及现金贷系统
    },
    {
      path: '/VirtualCreditCardSystem',
      name: 'VirtualCreditCardSystem',
      component: resolve => require(['@/components/ProductSolutions/NetworkIntegratedCreditAndRiskControl/VirtualCreditCardSystem'], resolve) // 虚拟信用卡系统
    },
    {
      path: '/CreditRiskControlDecisionModel',
      name: 'CreditRiskControlDecisionModel',
      component: resolve => require(['@/components/ProductSolutions/NetworkIntegratedCreditAndRiskControl/CreditRiskControlDecisionModel'], resolve) // 信用风控决策模型
    },
    {
      path: '/PostLoanCollectionModel',
      name: 'PostLoanCollectionModel',
      component: resolve => require(['@/components/ProductSolutions/NetworkIntegratedCreditAndRiskControl/PostLoanCollectionModel'], resolve) // 贷后催收模型
    },
    {
      path: '/CreditApprovalProcessManagementSystem',
      name: 'CreditApprovalProcessManagementSystem',
      component: resolve => require(['@/components/ProductSolutions/NetworkIntegratedCreditAndRiskControl/CreditApprovalProcessManagementSystem'], resolve) // 信贷审批流程管理系统
    },

    /*
      PointsMarketingEquityWriteOffSaasServices 文件夹为 "积分营销&权益核销Saas服务"
    */
    {
      path: '/PartenrRecreitment',
      name: 'PartenrRecreitment',
      component: resolve => require(['@/components/ProductSolutions/PointsMarketingEquityWriteOffSaasServices/PartenrRecreitment'], resolve) // 【合伙人】招募及推广系统
    },
    {
      path: '/InternetChannelMarketingPlatform',
      name: 'InternetChannelMarketingPlatform',
      component: resolve => require(['@/components/ProductSolutions/PointsMarketingEquityWriteOffSaasServices/InternetChannelMarketingPlatform'], resolve) // 互联网渠道营销平台
    },
    {
      path: '/IntegratedIntegralManagementSystem',
      name: 'IntegratedIntegralManagementSystem',
      component: resolve => require(['@/components/ProductSolutions/PointsMarketingEquityWriteOffSaasServices/IntegratedIntegralManagementSystem'], resolve) // 综合积分管理系统
    },
    {
      path: '/SaasServicePlatform',
      name: 'SaasServicePlatform',
      component: resolve => require(['@/components/ProductSolutions/PointsMarketingEquityWriteOffSaasServices/SaasServicePlatform'], resolve) // 权益核销Saas服务平台
    },

    /*
      IndustrySceneDigitizationSolutions 文件夹为 "行业&场景数字化解决方案"
    */
    {
      path: '/ManagementSystemOfMerchantMemberPrepaidCard',
      name: 'ManagementSystemOfMerchantMemberPrepaidCard',
      component: resolve => require(['@/components/ProductSolutions/IndustrySceneDigitizationSolutions/ManagementSystemOfMerchantMemberPrepaidCard'], resolve) // 商户会员预付卡管理系统
    },
    {
      path: '/ECommerceIntegratedTradingPlatform',
      name: 'ECommerceIntegratedTradingPlatform',
      component: resolve => require(['@/components/ProductSolutions/IndustrySceneDigitizationSolutions/ECommerceIntegratedTradingPlatform'], resolve) // 电商综合交易平台
    },
    {
      path: '/EducationPaymentManagementSystem',
      name: 'EducationPaymentManagementSystem',
      component: resolve => require(['@/components/ProductSolutions/IndustrySceneDigitizationSolutions/EducationPaymentManagementSystem'], resolve) // 教育缴费管理系统
    },
    {
      path: '/PropertyManagementSystem',
      name: 'PropertyManagementSystem',
      component: resolve => require(['@/components/ProductSolutions/IndustrySceneDigitizationSolutions/PropertyManagementSystem'], resolve) // 物业管理系统
    },
    {
      path: '/CentralKitchenCateringDistributionSystem',
      name: 'CentralKitchenCateringDistributionSystem',
      component: resolve => require(['@/components/ProductSolutions/IndustrySceneDigitizationSolutions/CentralKitchenCateringDistributionSystem'], resolve) // 中央厨房餐饮配送系统
    },

    /*
      HumanResourcesOutsourcingAndTestingServices 文件夹为 "人力资源外包及测试服务"
    */
    {
      path: '/IntegratedHumanResourceOutsourcingService',
      name: 'IntegratedHumanResourceOutsourcingService',
      component: resolve => require(['@/components/ProductSolutions/HumanResourcesOutsourcingAndTestingServices/IntegratedHumanResourceOutsourcingService'], resolve) // 综合人力资源外包服务
    },
    {
      path: '/InternetFinancialTestingAndManagementServices',
      name: 'InternetFinancialTestingAndManagementServices',
      component: resolve => require(['@/components/ProductSolutions/HumanResourcesOutsourcingAndTestingServices/InternetFinancialTestingAndManagementServices'], resolve) // 互联网金融测试及管理服务
    },
    {
      path: '/404',
      name: '404',
      component: resolve => require(['@/components/404'], resolve) // 404
    },
    {
      path: '*',
      redirect: '/404',
      name: '404Page'
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js